import {ref} from 'vue'

export const duplicateInvoiceLineUuids = ref<string[]>([])
